import React from 'react';
// import "./format5.css";

const Format6 = ({ modifyForm = {} }) => {
  const defaultColumns = [];

  const getVisibleColumns = (columns) => {
    let result = [];

    if (columns) {
      columns.forEach(col => {
        if (col.check) {
          result.push(col);
        }
      });
    }

    return result;
  };

  // Get visible columns from lr_table
  const visibleColumns = getVisibleColumns(modifyForm?.lr_table || defaultColumns);

  // Get active copy from copies array
  const activeCopy = modifyForm?.copies?.find(copy => copy.check) || {
    name: "Original Copy",
    value: 1
  };

  // Calculate column widths dynamically
  const calculateColumnWidth = () => {
    const columnCount = visibleColumns.length;
    if (columnCount <= 3) return '120px';
    if (columnCount === 4) return '90px';
    return '70px';
  };

  return (
    <>
      <style>
        {`@import url('https://fonts.googleapis.com/css?family=Roboto:400,500,700,900&display=swap');

        body {
            margin: 0px;
        }

        table {
            border-bottom: 0px;
        }

        td.text-leftNw6.width_75.font14 {
            font-size: 12px;
            position: relative;

        }

        table.table_gray_bgNw6 {
            background: #efefef !important;
            margin: 0;
            font-size: 13px;
            border-bottom: 1px solid #ccc;
            -webkit-print-color-adjust: exact;
            border-top: 1px solid #ccc;
            margin-top: -1px;
            border-right: 1px solid #ccc;
        }

        .table_gray_bgNw6 td {
            padding: 5px 15px !important;
        }

        .item_descriptionNw6 {
            margin: 2px 0;
        }

        .address_newNw6 {
            margin: 0px;
            margin-bottom: 5px;
        }

        .gst_invoiceno_tableNw6 .border_tableNw6 tr td:nth-child(1) {
            width: 75px !important;
        }

        .gst_invoiceno_tableNw6 .border_tableNw6 tr td:nth-child(2) {
            width: 110px !important;
        }

        .gst_invoiceno_tableNw6 .border_tableNw6 tr td:nth-child(3) {
            width: 110px !important;
        }

        .gst_invoiceno_tableNw6 .border_tableNw6 tr td:nth-child(4) {
            width: 110px !important;
        }

        .gst_invoiceno_tableNw6 .border_tableNw6 tr td:nth-child(5) {
            width: 60px !important;
        }

        .gst_invoiceno_tableNw6 .border_tableNw6 tr td:nth-child(6) {
            width: 60px !important;
        }

        .gst_invoiceno_tableNw6 .border_tableNw6 tr td:nth-child(7) {
            width: 60px !important;
        }

        .gst_invoiceno_tableNw6 .border_tableNw6 tr td:nth-child(8) {
            width: 70px !important;
        }

        .graY-bgNw6 {
            background: #000 !important;
            border-bottom: 1px solid #ccc;
            -webkit-print-color-adjust: exact;
            color: white;
        }

        .gst_invoiceno_tableNw6 td {
            height: 22px !important;
            border-top: 1px solid #efefef;
            line-height: 23px !important;
        }

        .height_div.gst_invoiceno_tableNw6 thead tr td {
            border-bottom: 1px solid #ccc !important;
        }


        .footerNw6.margintopNw6 {
            margin-top: 60px !important;
        }

        .new_tableNw6 td {
            line-height: 16px !important;
        }

        .poweredbyNw6 {
            position: absolute;
            right: 0;
            font-size: 11px;
            margin-top: 3px;
            padding-right: 15px
        }

        .footerNw6 p {
            margin: 0
        }

        .footerNw6 {
            margin-top: 60px;
            font-weight: 700;
            padding-left: 15px;
            padding-right: 15px
        }

        /* .padding-2mmNw6{padding:2mm}*/
        .invoice-boxNw6 {
            padding: 3px;
            font-size: 12px;
            line-height: 16px;
            font-family: Roboto, sans-serif;
            color: #222;
            margin: 0 auto
        }

        .border_b {
            border-bottom: 1px solid #ccc
        }

        .text_center {
            text-align: center;
            display: block
        }

        .bold_textNw6 {
            font-weight: 700
        }

        .border_boxNw6 {
            border: 1px solid #cccc
        }

        .p_0 {
            padding: 0 !important
        }

        span.poweredbyNw6 {
            position: absolute;
            bottom: -20px;
            text-align: right;
            width: 100%;
            right: 4px;
            font-size: 9px
        }

        .Gst_inNw6 {
            font-weight: 900 !important;
            margin-top: 4px !important;
            margin-bottom: 0 !important
        }

        .border_r {
            border-right: 1px solid #ccc
        }

        /*.Address{height:35px}*/
        .invoice-boxNw6 table {
            width: 100%;
            line-height: inherit;
            text-align: left;
            border-collapse: collapse;
            font-size: 12px;
        }

        .top_heading p {
            margin-top: 10px;
            font-size: 12px;
            font-weight: 400;
            line-height: 17px;
            margin-bottom: 10px
        }

        .height_div td {
            height: 18px
        }

        .top_heading_PNw6 {
            font-size: 22px !important;
            margin-bottom: 0 !important;
            margin-top: 0 !important;
            font-weight: 700 !important;
        }

        .left_tableNw6 {
            border-right: 1px solid #ccc
        }

        .invoice-boxNw6 table td {
            vertical-align: top;
            line-height: 20px
        }

        .text-leftNw6 {
            text-align: left
        }

        .border_tableNw6 thead td {
            font-weight: 700;
            padding: 6px 5px;
            font-size: 12px
        }

        .top_headingNw6 {
            padding: 10px 0 5px 15px
        }

        .invoice-boxNw6 table tr.information table td {
            padding-bottom: 40px
        }

        .invoice-boxNw6 table tr.heading td {
            background: #eee;
            border-bottom: 1px solid #ddd;
            font-weight: 700
        }

        .border_tableNw6 td {
            padding: 8px 5px;
            height: 18px
        }

        .invoice-boxNw6 table tr.details td {
            padding-bottom: 20px
        }

        .invoice-boxNw6 table tr.total td:nth-child(2) {
            border-top: 2px solid #eee;
            font-weight: 700
        }

        table.table_right thead td {
            padding: 0
        }

        .table_right td {
            padding: 3px 15px
        }

        td.text-leftNw6.width_75 {
            text-align: right
        }

        .width_35 {
            width: 50%
        }

        .height_div {
            position: relative
        }

        tr.bg_darkGray {
            background: #444 !important;
            color: #fff
        }

        tr.bg_darkGray td {
            background: #444 !important;
            color: #fff
        }

        .border_tableNw6 tr td:nth-child(1) {
            width: 80px;
            border-left: 0;
            padding-left: 15px
        }

        .border_tableNw6 tr td:nth-child(2) {
            width: 50px
        }

        .border_tableNw6 tr td:nth-child(3) {
            width: 150px
        }

        .border_tableNw6 tr td:nth-child(4) {
            width: 130px
        }

        .border_tableNw6 tr td:nth-child(5) {
            width: 76px;
            padding-right: 10px
        }

        .border_tableNw6 tr td:nth-child(6) {
            width: 150px
        }


        .address_bottom {
            margin: 0;
            height: 45px;
            line-height: 12px;
            padding-top: 0;
            margin-top: 0;
            font-size: 10px;
            padding-bottom: 4px
        }

        .address_bottom p {
            margin-bottom: 0
        }

        .AddressNw6 {
            font-weight: 400;
        }

        .AddressNw6 span {
            display: block;
            margin-bottom: 2px;
            line-height: 16px;
        }

        .border_tableNw6.border_none td {
            border-color: #fff !important;
            line-height: 24px
        }

        .top_heading_leftNw6 {
            text-align: left !important;
        }

        .sheet.padding-2mmNw6 {
            padding: 2mm;
            background: white;
        }

        .sheet-contentNw6 {
            transform-origin: top left;
            transition: transform 0.2s ease;
            width: 210mm;
            margin: 0 auto;
        }

        .loading_challiNw6 {
            padding-bottom: 5px;
        }

        .loading_challiNw6 td {
            border: 1px solid #000;
            text-align: center;
            padding: 0px;
            width: 0.21%;
        }

        .loading_challiNw6 td div {
            min-height: 20px;
            min-width: 30px;
            max-width: 33px;
            margin: 0 auto;
        }

        .loading_challiNw6 td p {
            margin: 0px;
            font-size: 11px;
            font-weight: 500;
        }

        @media (max-width: 319px) {
            .sheet-contentNw6 {
                transform: scale(calc(20% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 320px) and (max-width: 339px) {
            .sheet-contentNw6 {
                transform: scale(calc(20% * 2)) !important;
                transform-origin: 9px 0px;
            }
        }

        @media (min-width: 340px) and (max-width: 359px) {
            .sheet-contentNw6 {
                transform: scale(calc(20% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 360px) and (max-width: 379px) {
            .sheet-contentNw6 {
                transform: scale(calc(22% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 380px) and (max-width: 399px) {
            .sheet-contentNw6 {
                transform: scale(calc(24% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 400px) and (max-width: 419px) {
            .sheet-contentNw6 {
                transform: scale(calc(26% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 420px) and (max-width: 439px) {
            .sheet-contentNw6 {
                transform: scale(calc(26% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 440px) and (max-width: 459px) {
            .sheet-contentNw6 {
                transform: scale(calc(28% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 460px) and (max-width: 479px) {
            .sheet-contentNw6 {
                transform: scale(calc(28.6% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 480px) and (max-width: 499px) {
            .sheet-contentNw6 {
                transform: scale(calc(30% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 500px) and (max-width: 519px) {
            .sheet-contentNw6 {
                transform: scale(calc(30% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 520px) and (max-width: 539px) {
            .sheet-contentNw6 {
                transform: scale(calc(30% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 540px) and (max-width: 559px) {
            .sheet-contentNw6 {
                transform: scale(calc(33.6% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 560px) and (max-width: 579px) {
            .sheet-contentNw6 {
                transform: scale(calc(35% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 580px) and (max-width: 599px) {
            .sheet-contentNw6 {
                transform: scale(calc(36% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 600px) and (max-width: 629px) {
            .sheet-contentNw6 {
                transform: scale(calc(37.5% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 630px) and (max-width: 669px) {
            .sheet-contentNw6 {
                transform: scale(calc(38.6% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 670px) and (max-width: 699px) {
            .sheet-contentNw6 {
                transform: scale(calc(42% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 700px) and (max-width: 739px) {
            .sheet-contentNw6 {
                transform: scale(calc(44% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 740px) and (max-width: 769px) {
            .sheet-contentNw6 {
                transform: scale(calc(46% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 770px) and (max-width: 799px) {
            .sheet-contentNw6 {
                transform: scale(calc(48% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (max-width: 767px) {
            .sheet-contentNw6 {
                margin: 0 auto;
            }
        }

        @page {
            margin: 0px;
            padding: 10px 0;
        }

        @media print {
            .sheet-contentNw6 {
                transform: scale(1) !important;
            }
        }`}
      </style>


      <div className="A5 landscape">

        <div className="sheet-contentNw6">
          <section className="sheet padding-2mmNw6">
            <div id="printableArea221">
              <table style={{ pageBreakAfter: 'always', width: '100%' }} cellPadding="0" cellSpacing="0">
                <tbody>
                  <tr>
                    <td>
                      <div className="invoice-boxNw6">
                        <h3
                          style={{
                            fontSize: '10px',
                            textAlign: 'left',
                            fontFamily: 'Roboto,sans-serif',
                            textTransform: 'uppercase',
                            marginBottom: '0px',
                            marginTop: '0px',
                          }}
                        ></h3>
                        <div className="border_boxNw6">
                          <table cellpadding="0" cellspacing="0">
                            <tbody>
                              <tr className="top">
                                <td>
                                  <table cellpadding="0" cellspacing="0">
                                    <tbody>
                                      <tr>
                                        <td style={{ width: '60%' }} className="left_tableNw6">
                                          <table cellpadding="0" cellspacing="0">
                                            <thead>
                                              <tr>
                                                <th colSpan={2}
                                                  className="top_heading_leftNw6">

                                                  <div className="top_headingNw6">
                                                    <p className="top_heading_PNw6">
                                                      Sakshi Freight Carrier
                                                    </p>
                                                    <p className="AddressNw6">
                                                      <span>
                                                        125-A, SCHEME NO.78,
                                                        INDORE, Indore,
                                                        452001
                                                      </span>
                                                      <span>
                                                        sakshicarriers@gmail.com,
                                                        +91 9200031247
                                                      </span>
                                                    </p>
                                                    <p className="Gst_inNw6">
                                                      GST NO. 23ADGFS8194L2ZF
                                                    </p>
                                                  </div>

                                                </th>
                                              </tr>
                                            </thead>
                                          </table>
                                        </td>
                                        <td style={{ width: '40%' }}>
                                          <table className="table_right new_tableNw6"
                                            cellpadding="0" cellspacing="0">
                                            <thead>
                                              <tr>
                                                <td colSpan={2}>
                                                  <table className="table_gray_bgNw6">
                                                    <tbody>
                                                      <tr>
                                                        <td
                                                          className="bold_textNw6 width_35">
                                                          L.R.COPY
                                                        </td>
                                                        <td
                                                          className="text-leftNw6 width_75 font14">
                                                          <span>
                                                            (Original Copy)
                                                          </span>

                                                          <span
                                                            className="number">
                                                            (1)
                                                          </span>
                                                        </td>
                                                      </tr>
                                                    </tbody>
                                                  </table>
                                                </td>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              <tr>
                                                <td className="bold_textNw6 width_35">
                                                  Trip No.
                                                </td>
                                                <td className="text-leftNw6 width_75">
                                                  6026
                                                </td>
                                              </tr>
                                              <tr>
                                                <td className="bold_textNw6 width_35">
                                                  Vehicle No.
                                                </td>

                                                <td className="text-leftNw6 width_75">
                                                  MH40BG4590
                                                </td>
                                              </tr>
                                              <tr>
                                                <td className="bold_textNw6 width_35">
                                                  Date
                                                </td>
                                                <td className="text-leftNw6 width_75">
                                                  25/05/2024
                                                </td>
                                              </tr>
                                              <tr>
                                                <td className="bold_textNw6 width_35">
                                                  LR No.
                                                </td>
                                                <td className="text-leftNw6 width_75">
                                                  12345
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                              <tr>
                                <td style={{borderTop: '1px solid #ccc'}}>
                                  <table width="100%;" cellpadding="0" cellspacing="0">
                                    <tbody>
                                      <tr>
                                        <td
                                          style={{width: '50%', borderRight: '1px solid #ccc', paddingTop: '3px', paddingBottom: '3px', paddingRight: '0px'}}>
                                          <table style={{width: '100%'}} cellspacing="0"
                                            cellpadding="0">
                                            <tbody>
                                              <tr>
                                                <td colSpan={1}
                                                  style={{paddingLeft: '15px'}}>
                                                  <p style={{margin: '0px'}}>
                                                    <strong>
                                                      CONSIGNER-
                                                    </strong>
                                                    Parle Biscuites Pvt. Ltd.
                                                  </p>
                                                </td>
                                              </tr>
                                              <tr>
                                                <td colSpan={1}
                                                  style={{height: '40px', paddingLeft: '15px'}}>
                                                  <p
                                                    style={{marginBottom: '0px', marginTop: '0px'}}>
                                                    <strong>C/O- Market Loading Transportation </strong>
                                                  </p>
                                                  <p className="address_newNw6">
                                                    125 sector A scheme no. 78, indore- 452015
                                                  </p>
                                                </td>
                                              </tr>
                                              <tr>
                                                <td style={{paddingLeft: '15px'}}>
                                                  <p
                                                    style={{marginBottom: '5px', marginTop: '0px'}}>
                                                    <strong>GSTIN-</strong> LKJJ45100
                                                  </p>
                                                </td>
                                              </tr>
                                              <tr>
                                                <td
                                                  style={{paddingLeft: '15px', borderTop: '1px solid #ccc'}}>
                                                  <p className="item_descriptionNw6">
                                                    <strong>
                                                      Item Description-
                                                    </strong>
                                                    Biscuit Confectionary, Snacks
                                                  </p>
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </td>
                                        <td
                                          style={{width: '50%', paddingTop: '3px', paddingLeft: '8px', paddingBottom: '3px', paddingRight: '15px'}}>
                                          <table style={{width: '100%'}} cellspacing="0"
                                            cellpadding="0">
                                            <tbody>
                                              <tr>
                                                <td colSpan={1}>
                                                  <table>
                                                    <tbody>
                                                      <tr>
                                                        <td
                                                          style={{width: '15%'}}>
                                                          <strong>CONSIGNEE-
                                                          </strong>
                                                        </td>
                                                        <td colSpan={3}>
                                                          <span style={{width: '85%', fontWeight: 'bold'}}>
                                                            {/* <!-- <%= item?.consignee_id?.name || '' %> --> */}
                                                          </span>
                                                        </td>
                                                      </tr>
                                                      <tr>
                                                        <td style={{width: '15%', paddingBottom: '10px'}} >
                                                          <strong>ADDRESS-</strong>
                                                        </td>
                                                        <td colSpan={3} style={{width: '85%', paddingBottom: '10px', height: '44px'}} >
                                                          <span>
                                                            {/* <!-- <%= item?.consignee_id?.address_line1 || '' %>
                                                            <%= item?.consignee_id?.city?.value || '' %>
                                                            <%= item?.consignee_id?.state?.label || '' %>
                                                            <%= item?.consignee_id?.pincode || '' %> --> */}
                                                          </span>
                                                        </td>
                                                      </tr>
                                                      <tr>
                                                        <td style={{width: '15%'}}>
                                                          <strong>CONTACT-</strong>
                                                        </td>
                                                        <td colSpan={3}  style={{width: '85%'}}>
                                                          <span>
                                                            {/* <!-- <%= item?.consignee_id?.contact_no || '' %> --> */}
                                                          </span>
                                                        </td>
                                                      </tr>
                                                      <tr>
                                                        <td style={{width: '15%'}}>
                                                          <strong>GSTIN-</strong>
                                                        </td>
                                                        <td>
                                                          <span>
                                                            {/* <!-- <%= item?.consignee_id?.gst_no || '' %> --> */}
                                                          </span>
                                                        </td>
                                                        <td style={{width: '13%', textAlign: 'right'}} >
                                                          <strong>CODE-</strong>
                                                        </td>
                                                        <td style={{textAlign: 'right'}}>
                                                          <span>
                                                            {/* <!-- <%= item?.consignee_id?.code || '' %> --> */}
                                                          </span>
                                                        </td>
                                                      </tr>
                                                    </tbody>
                                                  </table>
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <div className="height_div gst_invoiceno_tableNw6">
                                    <table cellpadding="0" cellspacing="0"
                                      className="border_tableNw6 border_none">
                                      <thead>
                                        <tr>
                                          <td className="graY-bgNw6">Date</td>
                                          <td className="graY-bgNw6">Invoice No.</td>
                                          <td className="graY-bgNw6">GST Invoice No.</td>
                                          <td className="graY-bgNw6">Eway Bill No.</td>
                                          <td className="graY-bgNw6">Qty</td>
                                          <td className="graY-bgNw6">KOT</td>
                                          <td className="graY-bgNw6">Weight</td>
                                          <td className="graY-bgNw6">Sales Value</td>
                                        </tr>
                                      </thead>
                                      <tbody style={{width: '50%', borderBottom: '1px solid #ccc'}}>
                                        <tr>
                                          <td>25/05/2024</td>
                                          <td></td>
                                          <td></td>
                                          <td></td>
                                          <td></td>
                                          <td></td>
                                          <td>15000.00</td>
                                          <td></td>
                                        </tr>
                                      </tbody>
                                      <thead>
                                        <tr>
                                          <td className="graY-bgNw6">Total</td>
                                          <td className="graY-bgNw6">1</td>
                                          <td className="graY-bgNw6"></td>
                                          <td className="graY-bgNw6"></td>
                                          <td className="graY-bgNw6">0</td>
                                          <td className="graY-bgNw6">0</td>
                                          <td className="graY-bgNw6">15000</td>
                                          <td className="graY-bgNw6">0</td>
                                        </tr>
                                      </thead>
                                    </table>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <table cellpadding="0" cellspacing="0" className="holding_table">
                                    <tbody>
                                      <tr>
                                        <td style={{width: '100%', borderBottom: '1px solid #ccc', padding: '0px'}}>
                                          <p style={{fontWeight: 'bold', marginBottom: '0px', padding: '5px 15px', marginTop: '5px', lineHeight: '15px', fontSize: '10px'}}>
                                            <strong>Remark:</strong>
                                          </p>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td style={{width: '100%', borderBottom: '1px solid #ccc', padding: '0px'}}>
                                          <p style={{fontWeight: 'bold', marginBottom: '0px', padding: '5px 15px', marginTop: '5px', lineHeight: '15px', fontSize: '10px'}}>
                                            <strong>Loading Challi:</strong>
                                          </p>
                                          <div className="loading_challiNw6">
                                            <table>
                                              <tbody>
                                                <tr>
                                                  <td>
                                                    <div>
                                                      <p>5500</p>
                                                    </div>
                                                  </td>

                                                  <td>
                                                    <div>
                                                      <p>5500</p>
                                                    </div>
                                                  </td>

                                                  <td>
                                                    <div>
                                                      <p>5500</p>
                                                    </div>
                                                  </td>

                                                  <td>
                                                    <div>
                                                      <p>5500</p>
                                                    </div>
                                                  </td>

                                                  <td>
                                                    <div>
                                                      <p>5500</p>
                                                    </div>
                                                  </td>

                                                  <td>
                                                    <div>
                                                      <p>5500</p>
                                                    </div>
                                                  </td>

                                                  <td>
                                                    <div>
                                                      <p>5500</p>
                                                    </div>
                                                  </td>

                                                  <td>
                                                    <div>
                                                      <p>5500</p>
                                                    </div>
                                                  </td>

                                                  <td>
                                                    <div>
                                                      <p>5500</p>
                                                    </div>
                                                  </td>

                                                  <td>
                                                    <div>
                                                      <p>5500</p>
                                                    </div>
                                                  </td>

                                                  <td>
                                                    <div>
                                                      <p>5500</p>
                                                    </div>
                                                  </td>

                                                  <td>
                                                    <div>
                                                      <p>5500</p>
                                                    </div>
                                                  </td>

                                                  <td>
                                                    <div>
                                                      <p>5500</p>
                                                    </div>
                                                  </td>

                                                  <td>
                                                    <div>
                                                      <p>5500</p>
                                                    </div>
                                                  </td>

                                                  <td>
                                                    <div>
                                                      <p>5500</p>
                                                    </div>
                                                  </td>

                                                  <td>
                                                    <div>
                                                      <p>5500</p>
                                                    </div>
                                                  </td>

                                                  <td>
                                                    <div>
                                                      <p>5500</p>
                                                    </div>
                                                  </td>

                                                  <td>
                                                    <div>
                                                      <p>5500</p>
                                                    </div>
                                                  </td>

                                                  <td>
                                                    <div>
                                                      <p>5500</p>
                                                    </div>
                                                  </td>

                                                  <td>
                                                    <div>
                                                      <p>5500</p>
                                                    </div>
                                                  </td>

                                                  <td>
                                                    <div>
                                                      <p>5500</p>
                                                    </div>
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </div>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <table cellpadding="0" cellspacing="0" className="holding_table">
                                    <tbody>
                                      <tr>
                                        <td style={{width: '50%', borderRight: '1px solid #ccc'}}>
                                          <p style={{fontWeight: 'bold', paddingLeft: '15px', marginTop: '5px', lineHeight: '15px', fontSize: '10px'}}>
                                            <strong>Terms &amp; Conditions:</strong>
                                            {/* <!-- <%= format?.terms_conds || '' %> --> */}
                                          </p>
                                        </td>
                                        <td style={{width: '50%'}}>
                                          <table style={{width: '100%'}} cellspacing="0"
                                            cellpadding="0">
                                            <tbody>
                                              <tr>
                                                <td style={{width: '50%'}}>
                                                  <div className="footerNw6 margintopNw6" style={{textAlign: 'left'}}>
                                                    <p style={{color: '#707070', fontWeight: '400'}}>
                                                      Driver</p>
                                                  </div>
                                                </td>
                                                <td style={{width: '50%'}}>
                                                  <div className="footerNw6 margintopNw6" style={{textAlign: 'right'}}>
                                                    <p style={{color: '#707070', fontWeight: '400'}}>
                                                      Authorized Signature
                                                    </p>
                                                  </div>
                                                  {/* <!-- <div className="poweredbyNw6"
                                                    style="margin-top: 8px;">
                                                    Powered By:
                                                    <b>Transport360.in</b>
                                                  </div> --> */}
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>
        </div>

      </div>
    </>
  );
};

export default Format6;